<template>
  <div>
    <!--     header 顶部 -->
    <div class="header-warp">
      <!--      logo-->
      <div style="width: 300px">
        <img src="@/assets/logo.png" alt="" style="width: 60px; margin-left: 5px; vertical-align: middle">
        <span style="margin-left:5px; font-size: 20px; font-weight: normal; display: inline-block; vertical-align: middle; color: #3AA583;">青笺轩</span>
      </div>

      <div style="flex: 1; text-align: right; padding-right: 50px">
        <el-dropdown>
          <span class="el-dropdown-link" style="cursor: pointer">
            {{admin.username}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="margin-top: -10px;">
            <el-dropdown-item>
              <div style="width: 80px; text-align: center;" @click="logout">退出登录</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!--    侧边栏-->
    <div style="display: flex">
      <div style="width: 200px; min-height:calc(100vh - 62px); overflow: hidden; margin-right: 2px; background-color: white ">
        <el-menu :default-active="$route.path" class="el-menu-demo" router>
          <el-menu-item index="/home">
            <i class="el-icon-eleme"></i>
            <span style="font-weight: normal">数据中心</span>
          </el-menu-item>

          <el-menu-item index="/proverb">
            <i class="el-icon-collection"></i>
            <span slot="title">箴言管理</span>
          </el-menu-item>

          <el-menu-item index="/guess">
            <i class="el-icon-chat-round"></i>
            <span slot="title">问答管理</span>
          </el-menu-item>

          <el-submenu index="poem">
            <template slot="title">
              <i class="el-icon-reading"></i>
              <span>诗文管理</span>
            </template>
            <el-menu-item index="/poet">诗人管理</el-menu-item>
            <el-menu-item index="/poem">诗歌管理</el-menu-item>
          </el-submenu>

          <el-submenu index="zhenYan">
            <template slot="title">
              <i class="el-icon-notebook-1"></i>
              <span>文化管理</span>
            </template>
            <el-menu-item index="/festival">节日管理</el-menu-item>
            <el-menu-item index="/classical">古典文学</el-menu-item>
            <el-menu-item index="/knowledge">必备知识</el-menu-item>
          </el-submenu>

          <el-submenu index="admin">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>管理员管理</span>
            </template>
            <el-menu-item index="/addAdmin">管理员添加</el-menu-item>
            <el-menu-item index="/adminList">管理员列表</el-menu-item>
          </el-submenu>


        </el-menu>
      </div>

      <!--    内容  展示子路由  -->
      <div style="flex: 1; background-color: white">
        <router-view/>
      </div>

    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "Layout",
  data() {
    return {
      admin : Cookies.get('admin') ? JSON.parse(Cookies.get('admin')) : {}
    }
  },
  methods : {
    logout() {
      Cookies.remove('admin')
      this.$router.push('/login')
    }
  }
}
</script>

<style>

.header-warp {
  height:60px;
  line-height:60px;
  background-color: white;
  border-bottom: 2px #eee solid;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  display: flex
}
</style>
